import { useFeatureFlagEnabled } from 'posthog-js/react';

import { useGetUserMe } from '@/api/REST/userMe';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { isTest } from '@/legacy/utils/env';

export const useHasNewExpenseUI = () => {
  const { hasLegacyBillingPlan } = useGetUserMe();

  const rollOutEnabled = useFeatureFlagEnabled(FEATURE_FLAGS.NEW_EXPENSE_UI);

  if (hasLegacyBillingPlan || isTest) {
    return false;
  }

  return rollOutEnabled;
};
